import { SITE_CONTENT } from "../constants/siteContent";

const ENV_BASE_URL = (process.env.REACT_APP_SITE_URL || "").trim().replace(/\/$/, "");

const DEFAULT_SEO = {
  title: "Appinfigo | AI-Native Software Development for Founders and Product Teams",
  description:
    "Appinfigo is a small senior team that ships modern web, mobile, and AI-powered products. Fixed-scope pricing, founder-led delivery, code you own from day one.",
  keywords:
    "ai software development, ai mvp development, fixed price software development, custom ai app development, ai feature integration, senior software engineers india, ai startup mvp"
};

const PAGE_OVERRIDES = {
  "/": {
    title: "Appinfigo | Ship AI-Native Web and Mobile Products in Weeks",
    description:
      "Build modern software with AI features designed in from day one. Senior engineers, fixed-price scoping, transparent delivery. Talk to Appinfigo today.",
    keywords:
      "ai software development company, hire ai developers, ai mvp builder, fixed price app development, ai feature integration, custom saas development, founder-friendly development partner"
  },
  "/contact": {
    title: "Book a 30-min consult with Appinfigo | AI-Native Software Team",
    description:
      "Tell us what you want to build. We reply within one business day with a time to talk and a fixed-price estimate after the call.",
    keywords:
      "hire software development team, ai app development consult, fixed price quote software, talk to ai developers, mvp consultation"
  },
  "/pricing": {
    title: "Software Development Pricing in India | Fixed Price MVPs from ₹1.5L | Appinfigo",
    description:
      "Honest software development pricing in India. MVPs from ₹1.5L, SaaS platforms ₹5-18L, mobile apps ₹2.5-9L, AI features ₹1-5L (plus GST). Fixed quote after a one-week paid scoping sprint.",
    keywords:
      "software development cost in india, mvp development pricing india, fixed price app development india, saas development cost india, mobile app development cost india, ai feature integration cost, software development price india, indian software company pricing"
  },
  "/case-studies": {
    title: "Case Studies | Live Products Built by Appinfigo",
    description:
      "Live, in-production software we built. FlyJed travel platform, MMS Hubh Yatra pilgrimage booking, Topsel Trucking logistics portal, Toyota Stock Track inventory system.",
    keywords:
      "appinfigo case studies, software development case studies, travel booking platform built, logistics portal example, inventory management system case study"
  },
  "/about": {
    title: "About Appinfigo | Founder-Led Software Team in Prayagraj",
    description:
      "Small senior team. Founder-led delivery. Fixed-price builds. Code you own. AI features by default. Based in Prayagraj, working with clients across India, US, and UK.",
    keywords:
      "founder-led software development, boutique software agency india, senior software engineers, fixed price software development, prayagraj software company"
  },
  "/leadership": {
    title: "The Team | Appinfigo Founder and Senior Engineers",
    description:
      "Meet the four people building your product at Appinfigo. Founder-led, no account managers in between, direct Slack access to the team writing your code.",
    keywords:
      "appinfigo team, software development founder, senior engineers, boutique software firm team"
  },
  "/travel-logistics-solutions": {
    title: "Travel and Logistics Software Development | Booking Platforms, Logistics Portals",
    description:
      "We build travel booking sites, logistics dispatch portals, and operational platforms. Four shipped products in this space. Fixed price, 8-16 weeks delivery.",
    keywords:
      "travel booking platform development, logistics software development, dispatch portal development, travel booking website builder, fleet management software, pilgrimage booking platform"
  },
  "/fintech-banking-solutions": {
    title: "Fintech App and Portal Development | Lending Portals, KYC Flows, Ops Tools",
    description:
      "Customer-facing fintech apps and ops portals that sit on top of your core. KYC flows, lending portals, broker dashboards, document AI for underwriting. Fixed price.",
    keywords:
      "fintech app development, lending portal development, kyc flow development, broker portal software, fintech operations software, document ai underwriting"
  },
  "/healthcare-software-solutions": {
    title: "Healthcare Software Development | Booking, Patient Portals, Clinic Tools",
    description:
      "Online patient booking, intake forms, clinic admin portals, and document AI for healthcare. Not an EHR—we build the software around the existing one.",
    keywords:
      "healthcare software development, patient portal development, clinic booking software, healthcare app development india, hospital management software, telehealth integration"
  },
  "/real-estate-digital-solutions": {
    title: "Real Estate Software | Listing Sites, Broker Portals, CRM Tools",
    description:
      "Real estate listing websites, broker and agent portals, lead management tools. Mobile-first, WhatsApp-integrated, AI-enhanced. Fixed price, 6-12 weeks.",
    keywords:
      "real estate software development, property listing website, broker crm software, real estate portal development, real estate lead management software"
  },
  "/web-development-services": {
    title: "Web App Development | SaaS, Portals, Marketing Sites | Appinfigo",
    description:
      "SaaS apps, internal portals, customer-facing platforms, marketing sites. React, Next.js, Node, Postgres. Senior engineers, fixed price, ₹1.5L-12L MVPs (plus GST).",
    keywords:
      "web app development services, saas app development, react development company, nextjs development, custom web application development, fixed price web app"
  },
  "/mobile-app-development": {
    title: "Mobile App Development | iOS, Android, React Native | Appinfigo",
    description:
      "Cross-platform and native mobile apps. React Native default, Swift and Kotlin when needed. Store submission included. Fixed price, ₹2.5L-9L MVPs (plus GST).",
    keywords:
      "mobile app development company, react native development, ios app development, android app development, cross platform mobile app, fixed price mobile app"
  },
  "/data-and-ai": {
    title: "AI Feature Development | GenAI, Search, Document AI | Appinfigo",
    description:
      "AI features that ship and get used. Intelligent search, document AI, GenAI copilots, voice agents. OpenAI, Anthropic, open-source. ₹1L-5L v1 features (plus GST).",
    keywords:
      "ai feature development, genai integration, document ai development, ai chatbot for product, custom ai feature, openai integration, claude api integration"
  },
  "/product-engineering": {
    title: "Product Engineering | End-to-End Software Builds | Appinfigo",
    description:
      "From whiteboard to deployed product. Senior engineers, fixed price, weekly working demos, code you own. Most MVPs ship in 6-10 weeks.",
    keywords:
      "product engineering services, end to end software development, mvp development company, custom product development, fixed price product engineering"
  },
  "/engagement-model": {
    title: "How We Work and What It Costs | Appinfigo",
    description:
      "Three ways to engage: fixed-price product build, dedicated retainer pod, or team augmentation. All start with a paid scoping sprint and end with a fixed price.",
    keywords:
      "software engagement model, fixed price software development, software retainer pod, team augmentation india, software dedicated team"
  }
,
  "/zeta": {
    title: "Zeta — Grocery Delivery App by Appinfigo",
    description:
      "Daily needs, better prices, faster delivery. Snacks, groceries, personal care and home essentials, delivered by Zeta. Download free on Google Play.",
    keywords:
      "zeta app, zeta grocery delivery, appinfigo zeta, grocery delivery prayagraj, quick commerce app india, online grocery app"
  }
};

const STATIC_PATHS = [
  "/",
  "/contact",
  ...SITE_CONTENT.pages.map((page) => page.path)
];

const getPathWithoutTrailingSlash = (pathname) => {
  if (!pathname || pathname === "/") {
    return "/";
  }

  return pathname.replace(/\/+$/, "");
};

const getBaseUrl = () => {
  if (ENV_BASE_URL) {
    return ENV_BASE_URL;
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin.replace(/\/$/, "");
  }

  return "https://appinfigo.com";
};

const getPageBreadcrumbName = (pathname) => {
  if (pathname === "/") {
    return "Home";
  }

  const page = SITE_CONTENT.pages.find((item) => item.path === pathname);
  return page?.title || null;
};

export const isKnownPath = (pathname) => {
  const normalizedPath = getPathWithoutTrailingSlash(pathname);
  return STATIC_PATHS.includes(normalizedPath);
};

export const getSeoForPath = (pathname) => {
  const normalizedPath = getPathWithoutTrailingSlash(pathname);
  const baseUrl = getBaseUrl();
  const contentPage = SITE_CONTENT.pages.find((page) => page.path === normalizedPath);
  const pageOverride = PAGE_OVERRIDES[normalizedPath];
  const knownPath = isKnownPath(normalizedPath);

  const title =
    pageOverride?.title ||
    (contentPage ? `${contentPage.title} | Appinfigo` : DEFAULT_SEO.title);

  const description =
    pageOverride?.description ||
    contentPage?.subtitle ||
    DEFAULT_SEO.description;

  const keywords =
    pageOverride?.keywords ||
    (contentPage
      ? `${contentPage.eyebrow?.toLowerCase() || "software"}, ${contentPage.title.toLowerCase()}, appinfigo`
      : DEFAULT_SEO.keywords);

  return {
    title,
    description,
    keywords,
    canonicalUrl: knownPath
      ? `${baseUrl}${normalizedPath === "/" ? "" : normalizedPath}`
      : `${baseUrl}/`,
    image: `${baseUrl}/images/fav.png`,
    baseUrl,
    normalizedPath,
    isKnown: knownPath
  };
};

export const getStructuredData = ({ pathname, seo }) => {
  const normalizedPath = getPathWithoutTrailingSlash(pathname);
  const breadcrumbName = getPageBreadcrumbName(normalizedPath);
  const contentPage = SITE_CONTENT.pages.find((item) => item.path === normalizedPath);

  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Appinfigo",
    legalName: "Appinfigo Private Limited",
    url: seo.baseUrl,
    logo: `${seo.baseUrl}/images/logo.png`,
    description: "AI-native software development company. Founder-led senior team building web, mobile, and AI-powered products with fixed-price scoping.",
    founder: {
      "@type": "Person",
      name: "Akash Mishra",
      jobTitle: "Founder and CEO"
    },
    address: {
      "@type": "PostalAddress",
      addressLocality: "Prayagraj",
      addressRegion: "Uttar Pradesh",
      addressCountry: "IN"
    },
    areaServed: ["IN", "US", "GB", "AE"],
    knowsAbout: [
      "Web application development",
      "Mobile app development",
      "AI feature development",
      "SaaS platform engineering",
      "Travel and logistics software",
      "Cloud infrastructure"
    ],
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "sales",
        email: SITE_CONTENT.footer.email,
        telephone: SITE_CONTENT.footer.phone,
        availableLanguage: ["English", "Hindi"],
        areaServed: ["IN", "US", "GB", "AE"]
      }
    ]
  };

  const webPage = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: seo.title,
    description: seo.description,
    url: seo.canonicalUrl,
    isPartOf: {
      "@type": "WebSite",
      name: "Appinfigo",
      url: seo.baseUrl
    }
  };

  const breadcrumbItems = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: `${seo.baseUrl}/`
    }
  ];

  if (normalizedPath !== "/" && seo.isKnown && breadcrumbName) {
    breadcrumbItems.push({
      "@type": "ListItem",
      position: 2,
      name: breadcrumbName,
      item: seo.canonicalUrl
    });
  }

  const breadcrumbList = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbItems
  };

  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Appinfigo",
    url: seo.baseUrl,
    inLanguage: "en"
  };

  let service = null;
  let faq = null;
  let contactPage = null;

  if (normalizedPath === "/") {
    service = {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Software Product Engineering",
      serviceType: "Software Product Engineering",
      provider: {
        "@type": "Organization",
        name: "Appinfigo",
        url: seo.baseUrl
      },
      areaServed: "Worldwide"
    };

    faq = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: SITE_CONTENT.faq.items.slice(0, 6).map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer
        }
      }))
    };
  }

  if (normalizedPath === "/faq" && contentPage) {
    faq = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: contentPage.sections.map((item) => ({
        "@type": "Question",
        name: item.heading,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.body
        }
      }))
    };
  }

  if ((normalizedPath === "/services" || contentPage?.eyebrow === "Service") && contentPage) {
    service = {
      "@context": "https://schema.org",
      "@type": "Service",
      name: contentPage.title,
      description: contentPage.subtitle,
      provider: {
        "@type": "Organization",
        name: "Appinfigo",
        url: seo.baseUrl
      },
      areaServed: "Worldwide",
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: `${contentPage.title} Scope`,
        itemListElement: contentPage.sections.map((item) => ({
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: item.heading,
            description: item.body
          }
        }))
      }
    };
  }

  if (normalizedPath === "/contact") {
    contactPage = {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "Contact Appinfigo",
      description: "Talk to Appinfigo product and engineering specialists.",
      url: seo.canonicalUrl,
      about: {
        "@type": "Organization",
        name: "Appinfigo",
        email: SITE_CONTENT.footer.email,
        telephone: SITE_CONTENT.footer.phone,
        url: seo.baseUrl
      }
    };
  }

  let priceList = null;
  if (normalizedPath === "/pricing" && contentPage) {
    const priceTiers = [
      { name: "Marketing or listing site", low: 40000, high: 150000 },
      { name: "MVP web app", low: 150000, high: 600000 },
      { name: "Full SaaS or operational platform", low: 500000, high: 1800000 },
      { name: "Travel or logistics booking platform", low: 300000, high: 1200000 },
      { name: "Cross-platform mobile app", low: 250000, high: 900000 },
      { name: "AI features for existing product", low: 100000, high: 500000 },
      { name: "Monthly retainer", low: 50000, high: 250000 }
    ];

    priceList = {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Software Development Services",
      description: contentPage.subtitle,
      provider: {
        "@type": "Organization",
        name: "Appinfigo",
        url: seo.baseUrl
      },
      areaServed: ["IN", "US", "GB", "AE"],
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Appinfigo Pricing Tiers",
        itemListElement: priceTiers.map((tier) => ({
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: tier.name
          },
          priceSpecification: {
            "@type": "PriceSpecification",
            priceCurrency: "INR",
            minPrice: tier.low,
            maxPrice: tier.high,
            valueAddedTaxIncluded: false
          }
        }))
      }
    };

    if (contentPage.pageFaqs) {
      faq = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: contentPage.pageFaqs.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer
          }
        }))
      };
    }
  }

  return { organization, webPage, breadcrumbList, website, service, faq, contactPage, priceList };
};
